// Third-party
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

// Components
import { PrimaryLink } from '@/views/components/buttons';

// Types
import Locale from '@/types/locale';
import { ReduxState } from '@/redux/modules/types';

// Utils
import { FormattedMessage } from '@/utils/i18n';

type StateProps = {
  locale: Locale;
};

type Props = StateProps;

const AdminDataPortalHeader: React.FC<Props> = (props: Props) => {
  const onViewGuideClick = () => {
    window.open(`${import.meta.env.REACT_APP_HELP_SITE_URL}/${props.locale.toLowerCase()}`, '_blank');
  };

  return (
    <div className="data-portal-header">
      <h3>
        <FormattedMessage id="Admin.DataUpload.Header" />
      </h3>
      <PrimaryLink onClick={onViewGuideClick}>
        <FormattedMessage id="Admin.DataUpload.LinkViewGuide" />
        <i className="icon-expand-top-right" />
      </PrimaryLink>
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  locale: state.intl.locale,
});

export default withRouter(connect(mapStateToProps)(AdminDataPortalHeader));
